import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";

import "./Sidebar.scss";
import { routes } from "./routes";
import Icon from "../Icon";

const handleLogout = () => {
  localStorage.removeItem("refreshToken");
  window.location.href = `https://${process.env.REACT_APP_AUTH_HOSTNAME}/auth/logout?redirect_to=${window.location.origin}`;
};

const Sidebar = () => {
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 1024);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  // Close the drawer whenever navigation happens on mobile.
  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  const isActive = (path: string) => location.pathname === path;

  return (
    <>
      {isMobile && !isOpen && (
        <button
          className="rail-trigger"
          onClick={() => setIsOpen(true)}
          aria-label="Open navigation"
        >
          <img src="/logo.png" alt="Excel" />
        </button>
      )}

      {isMobile && isOpen && (
        <div className="rail-scrim" onClick={() => setIsOpen(false)} />
      )}

      <aside
        className={`rail${isMobile ? " rail--mobile" : ""}${
          isMobile && isOpen ? " rail--open" : ""
        }`}
      >
        <div
          className="rail__brand"
          onClick={isMobile ? () => setIsOpen(false) : undefined}
        >
          <NavLink to="/" className="rail__brand-link">
            <img src="/logo.png" alt="Excel Accounts" className="rail__logo" />
          </NavLink>
        </div>

        <nav className="rail__nav">
          {routes.map((route) => (
            <NavLink
              key={route.path}
              to={route.path}
              className={`rail__item${
                isActive(route.path) ? " rail__item--active" : ""
              }`}
              title={route.name}
              aria-label={route.name}
            >
              <Icon name={route.icon} />
              <span className="rail__label">{route.name}</span>
            </NavLink>
          ))}
        </nav>

        <div className="rail__spacer" />

        <div className="rail__footer">
          <button
            className="rail__item rail__item--danger"
            onClick={handleLogout}
            title="Logout"
            aria-label="Logout"
          >
            <Icon name="logout" />
            <span className="rail__label">Logout</span>
          </button>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
